import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthGuard } from '../auth/guard';
import { AuthGuardGuest } from '../auth/guard/auth.guard-guest';
import { LayoutComponent } from '../layout/layout.component';
import { CasinoComponent } from './dashboard/casino/casino.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { InPlayComponent } from './in-play/in-play.component';
import { SportListComponent } from './sport-list/sport-list.component';

const routes: Routes = [
  {
    path: "dashboard",
    redirectTo: "dashboard",
    pathMatch: "full",
  },
  {
    path: "",
    component: LayoutComponent,
    children: [
      {
        path: "dashboard",
        component: DashboardComponent,
        canActivate: [AuthGuardGuest],
      },
      {
        path: "sports/:sid",
        component: SportListComponent,
        canActivate: [AuthGuardGuest],
      },
      {
        path: "casino",
        component: CasinoComponent,
        canActivate: [AuthGuardGuest],
      },
      {
        path: "inplay",
        component: InPlayComponent,
        canActivate: [AuthGuardGuest],
      },
    ],
  },
  {
    path: "",
    loadChildren: () =>
      import("./sports/sports.module").then((m) => m.SportsModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GuestRoutingModule { }
